// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gwb-t","content":"styles_content__3q8md","row":"styles_row__11pyJ","footer":"styles_footer__3N5QN","phraseLength":"styles_phraseLength__2Z8Gh"};